/*
 * Copyright (c) 2026, Amblique
 * All rights reserved.
 */

/**
 * Cylindo 3D viewer theme
 * - root: wrapper Box (hides native AR part, layout)
 * - viewer: inline style for the custom element (aspect ratio)
 */
const CylindoViewer = {
  parts: ['root', 'viewer'],
  baseStyle: {
    root: {
      className: 'pdp-cylindo-wrapper',
      sx: {
        'paddingTop': {base: '45px', lg: '38px'},
        'cylindo-viewer::part(view-in-ar)': {
          display: 'none',
        },
        '& > cylindo-viewer': {
          minHeight: {base: 56.75, lg: 'unset'},
        },
      },
    },
    viewer: {
      aspectRatio: '256 / 123',
    },
  },
};

export default CylindoViewer;
